import {Pie}  from 'vue-chartjs'
import { mixins } from 'vue-class-component';
import ChartPlugin from '@/components/charts/add-plugin'
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
@Component
export default class PieChart extends mixins(Pie,Vue) {
  @Prop({type: Object})
  data: Object;
  @Prop({type: Object})
  options: Object;
  type: any ='pie'
  plugin : ChartPlugin= new ChartPlugin();
  mounted() {
    this.addPlugin(this.plugin.pluginConfig);
    this.renderChart(this.data,this.options);
  }
  @Watch('data')
  @Watch('options')
  updateChart() {
    this.renderChart(this.data,this.options);
  }
}